import { DeleteFilled } from '@ant-design/icons';
import { Form, message, Popconfirm, Switch, Tooltip } from 'antd';
import Table, { ColumnsType } from 'antd/lib/table';
import { calculateColumnsWidth } from 'api/common';
import {
  activateSource,
  deleteSource,
  getSourceList,
  SourceListData,
  SourcePagedList,
  SourcePayload,
  // updateSourcePayload,
} from 'api/master';
import { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

let payPagedList: SourcePagedList = {
  data: [],
  noOfRecords: 0,
};

type Props = {
  filter: SourcePayload;

  //handleReset: (values: SourcePayload) => Promise<void>;
};

const filterPayload: SourcePayload = {};
//const initSource: SourceListData[] = [];

const SourceList = ({ filter }: Props) => {
  const navigate = useNavigate();
  const [pagedList, setPagedList] = useState(payPagedList);
  const [_isLoading, setIsLoading] = useState(false);
  filter.Username = sessionStorage.getItem('user')?.toString();
  const [_isfilter, setFilter] = useState(filterPayload);
  //const [source, setNewSource] = useState(initSource);
  const [form] = Form.useForm<SourcePayload>();
  const [_isReset, _setReset] = useState(false);
  const [deleted, setDeleted] = useState(false);

  //filter.SourceApplicationName = sessionStorage.getItem('source')?.toString();
  const isAdmin = sessionStorage.getItem('isAdmin');
  if (isAdmin != 'true') {
    filter.SourceApplicationName = sessionStorage.getItem('source')?.toString();
  }

  useEffect(() => {
    debugger;
    setIsLoading(false);
    setPagedList(payPagedList);
    setFilter(filterPayload);
    setDeleted(false);
    // if (
    //   filter.SourceApplicationName != null ||
    //   filter.TypeofApplication != null ||
    //   filter.IsActive != null
    // ) {
    //   setSearch(true);
    //   getSearchList(filter)
    //     .then((res) => {
    //       debugger;
    //       if (res.data != null) {
    //         setPagedList(res.data);
    //       }
    //       else {
    //         message.warn('Searched Data not found!')
    //       }
    //     })
    //   setSearch(false);
    // } else {
    getSourceList(filter)
      .then((res) => {
        debugger;
        if (res.responseCode == '200' && res.message == 'Data Fetched!') {
          setPagedList(res.data);
        }
        if (res.responseCode == '200' && res.message == 'Data Not Found!' && deleted == false) {
          message.destroy();
          message.warn('Data Not Found');
        }
        // message.success('Success');
      })
      .finally(() => {
        setIsLoading(true);
        form.resetFields();
      });
    // }
  }, [filter, form]);

  const handleActive = (x: any) => {
    debugger;
    if (x.isActive == true) {
      x.updateIsActive = false;
    }
    if (x.isActive == false) {
      x.updateIsActive = true;
    }

    activateSource(x)
      .then((res) => {
        if (res.responseCode == '200') {
          message.success('Source Id updated!');
        } else {
          message.warn('Source Id Not updated!');
        }
      })
      .finally(() => {
        //form.resetFields();
        navigate('/master/source');
      });
  };

  // const handleDelete = (_s: any) => {
  //   setIsLoading(true);
  //   setDeleted(true);
  //   debugger;
  //   deleteSource(_s)
  //     .then((res) => {
  //       if (res != null) {
  //         message.success('Source Deleted!');
  //         form.resetFields();
  //       } else {
  //         message.error('Some Error Occured');
  //       }
  //     })
  //     .finally(() => {
  //       debugger;
  //       form.resetFields();
  //       setFilter(filterPayload);
  //       navigate('/master/source');
  //     });
  // };

  const handleDeletee = useCallback(
    async (values: SourcePayload) => {
      //const handleDelete = (_s: any) => {
      setIsLoading(true);
      setDeleted(true);
      debugger;
      deleteSource(values)
        .then((res) => {
          if (res != null) {
            message.success('Source Deleted!');
            form.resetFields();
          } else {
            message.error('Some Error Occured');
          }
        })
        .finally(() => {
          debugger;
          form.resetFields([]);
          navigate('/master/source');
        });
      //};
    },
    [filter, form]
  );

  const columns: ColumnsType<SourceListData> = [
    {
      key: 'SourceApplicationName',
      title: 'Source Application Name',
      dataIndex: 'SourceApplicationName',
      fixed: 'left',
      ellipsis: true,
      render: (_, record) => (
        // <Tooltip placement="topLeft" title={record}>
        //   {record}
        // </Tooltip>
        <>
          {/* <Button type="link" block onClick={() => handleUpdate(record)}>
            {_}
          </Button> */}
          <Link to="/master/source/updateSource" state={record}>
            {_}
          </Link>
        </>
      ),
    },
    {
      key: 'LoanTypes',
      title: 'Mapped Loan Types',
      dataIndex: 'LoanTypes',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'TypeOfApplication',
      title: 'Type of Application',
      dataIndex: 'TypeOfApplication',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'SecretKey',
      title: 'Secret Key',
      dataIndex: 'SecretKey',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'CreatedDate',
      title: 'Created On',
      dataIndex: 'CreatedDate',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'isActive',
      title: 'Is Active',
      dataIndex: 'isActive',
      ellipsis: true,
      render: (_, record) => (
        <>
          {record.isActive == true ? (
            <Popconfirm title="Make It InActive?" onConfirm={() => handleActive(record)}>
              {/* <Button type="primary">Active</Button> */}
              <Switch checked />
            </Popconfirm>
          ) : (
            <Popconfirm title="Make It Active?" onConfirm={() => handleActive(record)}>
              {/* <Button type="primary">InActive</Button> */}
              <Switch />
            </Popconfirm>
          )}
        </>
      ),
    },
    {
      key: 'Action',
      title: 'Action',
      dataIndex: 'action',
      ellipsis: true,
      render: (_, _record) => (
        <Popconfirm title="Sure to delete?" onConfirm={() => handleDeletee(_record)}>
          <a>
            <DeleteFilled style={{ fontSize: '16px', marginLeft: '50px' }} />
          </a>
        </Popconfirm>
      ),
    },
  ];

  // function getFullDate(date: string) {
  //   if (date != null) {
  //     let dateMoment = moment(new Date(date)).format('DD/MM/YYYY hh:mm:ss');
  //     return dateMoment;
  //   }
  // }

  const handleChange = (_pagination: any, _filters: any, sorter: any) => {
    if (sorter.hasOwnProperty('column')) {
      // params.order = { field: sorter.field, dir: sorter.order };
    }
    setIsLoading(false);

    filter.Username = sessionStorage.getItem('user')?.toString();
    if (isAdmin != 'true') {
      filter.SourceApplicationName = filter.SourceApplicationName;
    }

    filter.PageNo = _pagination.current;
    filter.PageSize = _pagination.pageSize;
    // if (isSearch == true) {
    //   debugger;
    //   getSearchList(filter).then((res) => {
    //     setPagedList(res.data);
    //     setIsLoading(true);
    //   });
    // } else {
    getSourceList(filter).then((res) => {
      setPagedList(res.data);
      setIsLoading(true);
    });
    // }
  };

  const maxWidthPerCell = 600;

  const dataTable = calculateColumnsWidth(columns, pagedList.data, maxWidthPerCell);
  const tableHeight = 500;
  const rowKey = 'ROWNUM';

  return (
    <>
      <Table
        dataSource={dataTable.source}
        columns={dataTable.columns}
        rowKey={rowKey}
        scroll={{ x: dataTable.tableWidth, y: tableHeight }}
        pagination={{
          pageSize: 10,
          total: pagedList.noOfRecords,
          current: pagedList.currentPageIndex == 0 ? 1 : pagedList.currentPageIndex,
        }}
        onChange={handleChange}
      />
      ;
    </>
  );
};
export default SourceList;
